import React from "react";

export const Tabs = ({ activeTab, setActiveTab }: any) => {
    return (
        <div className="mb-4 flex gap-6 border-b">
            <button
                onClick={() => setActiveTab("booth")}
                className={`pb-2 ${
                    activeTab === "booth" ? "border-b-2 border-blue-500 font-semibold" : "text-gray-400"
                }`}
            >
                Booth Wise
            </button>

            <button
                onClick={() => setActiveTab("piv")}
                className={`pb-2 ${
                    activeTab === "piv" ? "border-b-2 border-blue-500 font-semibold" : "text-gray-400"
                }`}
            >
                Ward Wise
            </button>

            <button
                onClick={() => setActiveTab("section")}
                className={`pb-2 ${
                    activeTab === "section" ? "border-b-2 border-blue-500 font-semibold" : "text-gray-400"
                }`}
            >
                Street Wise
            </button>
        </div>
    );
};
